import { logger } from './utils/logger'

export const CLIPBOARD_SYNC_STATUS = {
  NONE: 'NONE',
  PENDING: 'PENDING',
  DONE: 'DONE',
  FAIL: 'FAIL',
}

const MAX_CLIPBOARD_SIZE = 63.9 * 1024 // leave some space for packaging (proto)

const trimStringToBytesCount = ({
  input = '',
  length = 0,
}) => {
  try {
    let encoder = new TextEncoder()
    let decoder = new TextDecoder('utf-8')
    let uint8 = encoder.encode(input)
    const message = uint8.slice(0, length)
    logger('Message size', message.length)
    return decoder.decode(message)
  } catch (error) {
    console.error(error) // eslint-disable-line
    return input
  }
}

export const writeTextToClipboard = (text) => {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    return navigator.clipboard.writeText(text)
  }
  throw new Error('Writing text to clipboard is unsupported')
}

export const readTextFromClipboard = async (event) => { // eslint-disable-line require-await
  const isContentString = [...event.clipboardData.items]
    .reduce((accumulator, { kind }) => (kind === 'string' ? accumulator : false), true)

  if (!isContentString) {
    throw new Error('Unsupported clipboard content')
  }

  return trimStringToBytesCount({
    input: event.clipboardData.getData('text/plain'),
    length: MAX_CLIPBOARD_SIZE,
  })
}
